import React from "react";

import "easymde/dist/easymde.min.css";
import { createRoot } from "react-dom/client";

import { Config } from "config";

import App from "./App";
import { initializeMsalInstance } from "./identity/AuthProvider";
import "./index.css";

// Add "config" file to "Window" type
declare global {
  interface Window {
    config: Config;
    configPromise: Promise<Response>;
  }
}

const container = document.getElementById("root");
const root = createRoot(container!);
const msalInstance = await initializeMsalInstance();

root.render(<App msalInstance={msalInstance} />);
